import { Injectable } from '@angular/core';
import { CrossStudyPortalAppConfig } from '../interfaces/app-config';
import { AppConfigLoaderService } from './app-config-loader.service';

@Injectable({
  providedIn: 'root',
})
export class IntercomUrlService {
  private _intercomUrl: string | undefined;

  constructor(appConfig: AppConfigLoaderService<CrossStudyPortalAppConfig>) {
    appConfig.getConfig$()?.subscribe({
      next: v => {
        this._intercomUrl = v.intercomUrl;
      },
      error: () => console.warn('error while setting intercomUrl'),
    });
  }

  get(): string {
    if (!this._intercomUrl) throw new Error('intercomUrl is not set. it must be set during initialization');
    return this._intercomUrl;
  }
}
